enum SubTotalType {
  DEVELOPERS = 'DEVELOPERS',
  DISCOUNTS = 'DISCOUNTS'
}

export default SubTotalType;
